module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABZElEQVQ4jZ3Sv0vVYRTH8de9XAxECNScHLpSIEEg2JCFW+TkoIIQLTa4KaGT/g9OVoQZWhcb3BoCJ8FBvdYlxFx1UCLIwtVFxOF7lK9yf6hnefic83ne53nO82QKhYIqMYXXeIPxSqZsFcBdjGE2QPmbQIaxixHshL4WJIchfMRJnOZV5K8MGUAzPoX+jEYMVurYg1G04k5srsNbHITvH97jC+bxP3J/MJ3DAkr4GoUD/Mb3Sw3HsRjNWqLhIyzkgtaEdwGpFCcopnQzvmE/i140YA1tVSDpyIf/Nvqy2Ec3/kahowbgIdYlc3mKvbPXOcRz/MRcDcgcNvEs9l144qPoUPYvpOIWVsPvMgS68KMGZENyjfNIQzJ4El3O9BCWYs1Efh2PU/oCpF3yK4u4h2V8iGPPhL4vGX4jHpSDtOEYL/AL9ehEv+RT1WMLL8OXLwdZkcxjFJNxte2obYeeiHop/OAUCS5NIKDFU8IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/Collection.png
// module id = ISPo
// module chunks = 0